
import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import { RevisionUiItem } from "@/types/revisions";
import RevisionItem from "@/components/Reusable/Revisions/RevisionItem.vue";

@Component({
  components: { RevisionItem }
})
export default class RevisionsList extends Vue {
  @Prop({ default: false })
  isLoading!: boolean;

  @Prop({ default: [] })
  revisions!: RevisionUiItem[];

  @Prop({ default: null })
  revisionsNotSupportedMessage!: string | null;

  onRevisionSelected(revision: RevisionUiItem, index: number) {
    this.$emit("revisionSelected", revision, index);
  }
}
